/**
 * Full years elapsed since an ISO start date (e.g. "2017-03-01"),
 * evaluated against the current date. Used to keep the "years of
 * experience" figure up to date on its own — no manual edits.
 */
export function fullYearsSince(startISO: string, now: Date = new Date()): number {
  const start = new Date(startISO);
  if (Number.isNaN(start.getTime())) return 0;

  let years = now.getFullYear() - start.getFullYear();
  const beforeAnniversary =
    now.getMonth() < start.getMonth() ||
    (now.getMonth() === start.getMonth() && now.getDate() < start.getDate());
  if (beforeAnniversary) years -= 1;

  return Math.max(0, years);
}

/** e.g. "9+" — floored full years with a trailing plus. */
export function experienceLabel(startISO: string, now: Date = new Date()): string {
  return `${fullYearsSince(startISO, now)}+`;
}
